import { ProjectStatus } from '../../../domain/projectStatus/projectStatus';
import { ProjectStatusList } from '../../../domain/projectStatus/projectStatusList';
import { ProjectStatusListDTO } from '../../http/dtos/projectStatus/ProjectStatusListDTO';
import { ProjectStatusDTO } from '../../http/dtos/projectStatus/projectStatusDTO';

const getProjectStatusListAdapter = (
    responseAPI: ProjectStatusListDTO[]
): ProjectStatusList[] => {
    return responseAPI
        ? responseAPI.map((project) => {
              return {
                  id: project.id,
                  name: project.name,
                  description: project.description,
              };
          })
        : [];
};

const getProjectStatusAdapter = (responseAPI: ProjectStatusDTO): ProjectStatus => {
    return {
        id: responseAPI.id,
        name: responseAPI.name,
        description: responseAPI.description,
        color: responseAPI.color,
    };
};

export const ProjectStatusAdapter = {
    getProjectStatusAdapter,
    getProjectStatusListAdapter,
};
